var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value!==null)?_c('div',{ref:"number",class:_vm.numberClasses,style:(_vm.style)},[_vm._v("\n    "+_vm._s(_vm.currentValue)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }